import { PromptModelSummary } from '~/api/sylvanus/typedefs.autogen';
import { sylvanus } from '~/services/serviceInstances';

type Response = PromptModelSummary;

export const getModelSummary = async () => {
  const response: Response = await sylvanus.get(`/models/summary`);

  return response;
};
